import React from "react";
import { observer } from "mobx-react-lite";
import { DateInput3 } from "@blueprintjs/datetime2";
import { FormGroupWithRequired } from "./Components";
import type { IDateAttrEditorProps, EditorWithFormGroup } from "./_types";
import { Intent } from "@blueprintjs/core";

// DateAttrEditor
export const DateAttrEditor = observer(<D, K extends keyof D>(props: IDateAttrEditorProps<D, K>) => {
	const { store, ...rest } = props;
	let value = store.data[rest.name];

	// Change handler
	const onChange = (newDate: string, isUserChange: boolean) => {
		if (props.dateInputProps?.onChange) props.dateInputProps.onChange(newDate, isUserChange);
		else store.set(props.name, newDate);
	};

	// --

	return <DateInput3 {...rest} onChange={onChange} value={value as any} />;
});

// DateAttrEditorGrouo
export const DateAttrEditorGroup = <D, K extends keyof D>(props: React.PropsWithChildren<EditorWithFormGroup<IDateAttrEditorProps<D, K>>>) => {
	return (
		<FormGroupWithRequired required={props.dateInputProps.inputProps?.required} {...props.formGroupProps}>
			<DateAttrEditor dateInputProps={props.dateInputProps} store={props.store} name={props.name} />

			{props.children}
		</FormGroupWithRequired>
	);
};

// DateAttrEditorGrouoWithError
export const DateAttrEditorGroupWithError = observer(
	<D, K extends keyof D>(props: React.PropsWithChildren<{ error?: string } & EditorWithFormGroup<IDateAttrEditorProps<D, K>>>) => {
		const error = props.error ?? props.store.validation.errors.get(props.name);
		const intent: Intent = error ? "danger" : props.dateInputProps.inputProps?.intent;

		// --

		return (
			<FormGroupWithRequired
				required={props.dateInputProps.inputProps?.required}
				{...props.formGroupProps}
				helperText={<span dangerouslySetInnerHTML={{ __html: error ?? (props.formGroupProps.helperText as any) ?? "&nbsp;" }} />}
				intent={intent}
			>
				<DateAttrEditor {...props.dateInputProps} store={props.store} name={props.name} dateInputProps={props.dateInputProps} />

				{props.children}
			</FormGroupWithRequired>
		);
	}
);
